<template>
    <div class="nav-hamb-mob animated ani-screen-right">
        <div class="header-mob flex justify-between items-center lg:hidden py-5 px-5">
            <svg viewBox="0 0 90 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M55.8336 13.0978L65.788 11.9751C65.3388 8.30645 63.9169 5.46367 61.3736 3.29317C58.8273 1.04781 55.3847 0 50.9689 0C46.7036 0 43.1101 0.972949 40.0415 2.91885C37.9158 4.29603 36.105 6.10666 34.7276 8.23219C34.6164 6.99134 34.2331 5.79026 33.6049 4.71442C32.8049 3.34008 31.6035 2.24347 30.162 1.57187C28.6653 0.898084 26.4199 0.524056 23.4262 0.524056H7.5584L0 35.3265H10.8525L13.5467 22.4533H18.3369L18.7112 15.5678H15.0425L16.8387 7.33559H21.0311C23.3514 7.33559 24.474 8.38341 24.474 10.479C24.474 11.8263 23.8754 13.0239 22.8276 14.0717C21.7798 15.0446 20.4116 15.4022 18.7115 15.5687L18.3369 22.4533C21.8323 22.4094 25.2224 22.0041 27.318 21.106C28.6512 20.5662 29.8702 19.7789 30.9107 18.7858C30.8358 19.609 30.7615 20.5071 30.7615 21.2557C30.7615 25.6701 32.1088 29.2639 34.7285 31.9585C37.4227 34.6527 41.24 36 46.2544 36C51.0443 36 54.9364 34.8025 58.0062 32.3313C60.913 29.9797 63.0286 26.7932 64.0679 23.2016L54.0386 21.6298C53.2154 23.8003 52.1676 25.4476 51.0449 26.4196C49.9058 27.4693 48.4021 28.0332 46.8537 27.9915C45.0575 27.9915 43.7102 27.3929 42.8121 26.2702C41.8392 25.0727 41.39 23.6505 41.39 21.9292C41.4062 19.5144 41.8891 17.1255 42.8121 14.894C43.7102 12.4989 44.9078 10.7027 46.4048 9.58006C47.7042 8.48378 49.3452 7.87505 51.0452 7.85875C52.2726 7.85663 53.4627 8.27981 54.4132 9.0563C55.4611 9.87952 55.9103 11.1519 55.9103 12.8741V13.0987L55.8336 13.0978Z" fill="white"/><path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M89.8129 0.224609H81.4316L59.2017 21.1809L59.1268 21.7049L65.264 22.6779L67.4345 21.7049L79.1108 10.7027L79.2599 10.7776L76.8648 21.7049H67.4345L65.264 22.6779C64.7519 24.326 64.0485 25.9084 63.1684 27.3929L62.1205 29.1894H75.2184L73.7962 35.7009H82.1039L83.5251 29.1894H87.9395L89.5859 21.7049H85.0227L89.8129 0.224609Z" fill="white"/></svg>
            <div class="hamb-nav" @click="closeModal">
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.29303 1.29308C1.48056 1.10561 1.73487 1.00029 2.00003 1.00029C2.26519 1.00029 2.5195 1.10561 2.70703 1.29308L8.00003 6.58608L13.293 1.29308C13.3853 1.19757 13.4956 1.12139 13.6176 1.06898C13.7396 1.01657 13.8709 0.988985 14.0036 0.987831C14.1364 0.986677 14.2681 1.01198 14.391 1.06226C14.5139 1.11254 14.6255 1.18679 14.7194 1.28069C14.8133 1.37458 14.8876 1.48623 14.9379 1.60913C14.9881 1.73202 15.0134 1.8637 15.0123 1.99648C15.0111 2.12926 14.9835 2.26048 14.9311 2.38249C14.8787 2.50449 14.8025 2.61483 14.707 2.70708L9.41403 8.00008L14.707 13.2931C14.8892 13.4817 14.99 13.7343 14.9877 13.9965C14.9854 14.2587 14.8803 14.5095 14.6948 14.6949C14.5094 14.8803 14.2586 14.9855 13.9964 14.9878C13.7342 14.99 13.4816 14.8892 13.293 14.7071L8.00003 9.41408L2.70703 14.7071C2.51843 14.8892 2.26583 14.99 2.00363 14.9878C1.74143 14.9855 1.49062 14.8803 1.30521 14.6949C1.1198 14.5095 1.01464 14.2587 1.01236 13.9965C1.01008 13.7343 1.11087 13.4817 1.29303 13.2931L6.58603 8.00008L1.29303 2.70708C1.10556 2.51955 1.00024 2.26525 1.00024 2.00008C1.00024 1.73492 1.10556 1.48061 1.29303 1.29308Z" fill="white"/></svg>
            </div>
        </div>
        <div class="mt-20 sm:mt-32 grid grid-cols-12 pb-5">
            <div class="col-start-3 col-span-8">
                <div class="items-nav space-y-5">
                    <Link href="/" class="text-medium-size block ">
                        Home
                    </Link>
                    <Link href="/quem-somos" class="text-medium-size block ">
                        Quem Somos
                    </Link>
                    <Dropdown>
                        <template #title>
                            <h2 class="text-medium-size">Portfólio</h2>
                        </template>
                        <template #items>
                            <div class="portfolio-items">
                                <Dropdown>
                                    <template #title>
                                        <h4>Energia e Utilities</h4>
                                    </template>
                                    <template #items>
                                        <div class="projects-list">
                                            <div
                                                v-for="project in projects[0]" :key="project.index"
                                                :class="`${project.index === projectShowing.index? 'project-showing': 'light-text-gray-list'}`"
                                            >
                                                <Link :href="`/projetos/${project.path}`">
                                                    {{project.text}}
                                                </Link>
                                            </div>
                                        </div>

                                    </template>
                                </Dropdown>
                                <Dropdown>
                                    <template #title>
                                        <h4>Transformação Digital</h4>
                                    </template>
                                    <template #items>
                                        <div class="projects-list">
                                            <div
                                                v-for="project in projects[1]" :key="project.index"
                                                :class="`${project.index === projectShowing.index? 'project-showing': 'light-text-gray-list'}`"
                                            >
                                                <Link :href="`/projetos/${project.path}`">
                                                    {{project.text}}
                                                </Link>
                                            </div>
                                        </div>

                                    </template>
                                </Dropdown>
                                <!-- <Dropdown>
                                    <template #title>
                                        <h4>Educação à Distância</h4>
                                    </template>
                                    <template #items>
                                        <div class="projects-list">
                                            <a
                                                :class="`${projects[2][0].index === projectShowing.index? 'project-showing': 'light-text-gray-list'}`"
                                                href="#portfolio-portfolio-main-content"
                                            >
                                            {{projects[2][0].text}}
                                            </a>
                                        </div>

                                    </template>
                                </Dropdown> -->
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { Link } from '@inertiajs/inertia-vue3';
import Dropdown from "@/Components/DropdownArrow.vue";

const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close', true);
};

const projectShowing = ref({});
const projects = ref([
    [
        {
            text: 'Gestão de Projetos',
            index: 0,
            path: 'SGP4'
        },
        {
            text: 'Chamadas Públicas',
            index: 1,
            path: 'ChamadaPublica'
        },
        {
            text: 'Calculadora de Carbono',
            index: 2,
            path: 'PegadaDeCarbono'
        },
        {
            text: 'Simulador de Consumo',
            index: 3,
            path: 'SimuladorDeConsumo'
        },
    ],
    [
        {
            text: 'Gestão de Reuniões',
            index: 4,
            path: 'Reuna.me'
        },
        // {
        //     text:'Sistema de Horas-extras',
        //     index:5,
        //     path:'horas-extras'
        // },
    ],
    // [
    //     {
    //         text:'Plataforma de Ensino',
    //         index:6,
    //         path:'nitro'
    //     },
    // ],
]);
/*
import Dropdown from "@/components/DropdownArrow.vue"
export default {
    components:{
        Dropdown
    },
    data(){
        return {
            projectShowing:{},
            projects:[
                [
                    {
                        text:'Gestão de Projetos',
                        index:0,
                        path:'SGP4'
                    },
                    {
                        text:'Chamadas Públicas',
                        index:1,
                        path:'ChamadaPublica'
                    },
                    {
                        text:'Calculadora de Carbono',
                        index:2,
                        path:'PegadaDeCarbono'
                    },
                    {
                        text:'Simulador de Consumo',
                        index:3,
                        path:'SimuladorDeConsumo'
                    },
                ],
                [
                    {
                        text:'Gestão de Reuniões',
                        index:4,
                        path:'Reuna.me'
                    },
                    // {
                    //     text:'Sistema de Horas-extras',
                    //     index:5,
                    //     path:'horas-extras'
                    // },
                ],
                // [
                //     {
                //         text:'Plataforma de Ensino',
                //         index:6,
                //         path:'nitro'
                //     },
                // ],
            ],
        }
    },
    methods:{
        closeModal(){
            this.$emit('close',true);
        },
    },
}
*/
</script>

<style lang="postcss" scoped>

.header-mob svg {
    height: 20px;
}

.nav-hamb-mob {
    overflow: auto;
    max-height: 100vh;
    color: white;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 101;
    background-color: #3662AD;

    @apply h-screen w-screen;
}

.projects-list {
    @apply flex flex-col space-y-2;
}

h4 {
    font-size: 1rem;
    @apply font-semibold my-2;
}

.text-medium-size{
    @apply font-bold;
}

.items-nav{
    & > :not(:last-child){
        @apply mb-5;
    }
}
</style>
